module.exports = __webpack_public_path__ + "media/images/home/mini/sc1-625b44febaf73aaf6b7e6b7719e80b70.png";